import { initialResult } from 'local/test/data';
import agent from 'local/test/agent';

/**
 * Reset the test. This will clear all data and send a resetTest message to the
 * agent. The agent will then prepare for a new test and send agentReady when
 * it's ready. The client should then send a startTest message.
 *
 * {@link https://github.com/dotse/bredbandskollen/wiki/Agent-API-v2#instructions-that-the-agent-should-be-able-to-receive}
 */
export default function reset(m) {
	// We set startRequested to true to instruct the client to start the test
	// as soon as the agent is ready.
	m.setData({
		startRequested: true,
		started: false,
		completed: false,
		result: { ...initialResult },
		report: null,
		currentMeasurementID: null,
		currentMeasurementInfo: null,
		currentTest: null,
		operatorInfoMessage: null,
		operatorBadInfoMessage: null,
		rating: null,
		error: false,
		errno: null,
	});

	agent.send({ method: 'resetTest' });
}
